(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabActions', TabActions);

    TabActions.$inject = ['$resource'];

    function TabActions($resource) {
        var resourceUrl = 'api/tab-actions/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'search': {url: 'api/tab-actions/search', method: 'POST', isArray: true},
            'command': {
                method: 'GET',
                isArray: true,
                cache: false,
                url: 'api/tab-actions/object/:id'
            },
            'allCommand': {
                method: 'GET',
                isArray: true,
                cache: false,
                url: 'api/tab-actions/type/:typeId/fleet/:fleetId'
            },
            'allDownload': {
                method: 'GET',
                isArray: true,
                cache: false,
                url: 'api/tab-actions/type/fleet'
            },
            'download': {
                method: 'GET',
                url: 'api/tab-actions/type/:typeId/fleet/:fleetId/download'
            },
            'multiple': {
                method: 'GET',
                isArray: true,
                cache: false,
                url: 'api/tab-actions/multiple'
            },
            'commandsByObjects': {
                method: 'POST',
                isArray: true,
                url: 'api/tab-actions/commands-by-objects'
            },
            'actionsByObjectType': {
                method: 'GET',
                isArray: true,
                url: 'api/tab-actions/objectType/:id'
            }
        });
    }
})();
